// extracted by mini-css-extract-plugin
export default {"SearchIcon":"SearchButton_SearchIcon__nagXe","SearchFilter":"SearchButton_SearchFilter__nLgJH"};